import React, { useState, useEffect, useRef } from 'react';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Overlay from 'react-bootstrap/lib/Overlay';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import ReactHtmlParser from 'react-html-parser';

const CustomFormGroup = ({
  valid,
  validating = false,
  validationMessage,
  tooltipPosition,
  showPopover: initialShowPopover,
  extraClass,
  children,
  className,
  ...remainingProps
}) => {
  const [topOffset, setTopOffset] = useState('0px');
  const [showPopover, setShowPopover] = useState(initialShowPopover);
  const containerRef = useRef(null);
  const targetRef = useRef(null);

  const iconHeight = 34;
  const controlLabelHeight = 27;

  useEffect(() => {
    if (containerRef.current) {
      let newOffset = (containerRef.current.offsetHeight / 2) - (iconHeight / 2);
      let controlLabelExists = React.Children.toArray(children).filter(c => c.type && c.type.name === 'ControlLabel').length > 0;
      if (controlLabelExists) {
        newOffset += (controlLabelHeight / 2);
      }
      setTopOffset(`${newOffset}px`);
    }
  }, [children]);

  useEffect(() => {
    let interval;
    if (typeof initialShowPopover === 'boolean') {
      if (initialShowPopover) {
        interval = setInterval(() => setShowPopover(true), 1500);
      } else {
        setShowPopover(false);
      }
    }
    return () => clearInterval(interval);
  }, [initialShowPopover]);

  const shouldValidate = validating || typeof valid === 'boolean';

  const popoverPlacement = () => {
    let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (width <= 1100) return 'top';
    return tooltipPosition || 'left';
  };

  const renderIcon = () => {
    if (!shouldValidate) return null;
    return (
      <span
        className={`form-control-feedback ${extraClass || ''}`}
        style={{ top: topOffset }}>
        <i className={validating ? 'fa fa-spinner fa-spin fa-2x' : `fa fa-${valid ? 'check-circle' : 'times-circle'} fa-2x`}></i>
      </span>
    );
  };

  const renderPopover = () => {
    const isVisible = !validating && shouldValidate && showPopover && validationMessage && valid === false;
    return (
      <Overlay
        show={isVisible}
        target={() => targetRef.current}
        placement={popoverPlacement()}>
        <Tooltip id={`overload-${popoverPlacement()}`}>
          { ReactHtmlParser(validationMessage) }
        </Tooltip>
      </Overlay>
    );
  };

  const formGroupClass = () => {
    if (validating) return 'form-group has-feedback';

    return shouldValidate
      ? `form-group has-feedback has-${valid ? 'success' : 'error'}`
      : `form-group`;
  };

  return (
    <div ref={containerRef}>
      <div
        {...remainingProps}
        className={`${className || ''} ${formGroupClass()}`}
        ref={fg => { targetRef.current = fg; }} >
        {renderIcon()}
        {children}
      </div>
      {renderPopover()}
    </div>
  );
};

export default CustomFormGroup;
